import { LanguageSection } from './language-section';
import TrainingSection from './training-section';
import CertificationSection from './certification-section';
import { WorkerExperiencesSection } from './worker-experience-section';

import { cn } from '@restworld/utils-common';
export const WorkerSkillsAndLanguage = () => {
  return (
    <div className="flex flex-col items-start gap-6 pb-4">
      <WorkerExperiencesSection />
      <LanguageSection />
      <TrainingSection />
      <CertificationSection />
    </div>
  );
};

export const StyledSeparator = ({ className, ...props }: React.HTMLAttributes<HTMLElement>) => (
  <hr className={cn('block w-full border-t border-primary-300 h-px my-6', className)} {...props} />
);
